export default "__VITE_ASSET__8fb9b638__"